













import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { FormItem } from 'element-ui';
import NullableInput from '@/components/element-ui/NullableInput.vue';
import UtcDatePicker from '@/components/element-ui/UtcDatePicker.vue';
import {
  MilestoneFields,
  MilestoneInput,
  MilestoneTypeEnum
} from '@/types/graphql/schemaTypes';
import get from 'lodash/get';
import debounce from 'lodash/debounce';

@Component({
  components: {
    UtcDatePicker,
    'el-form-item': FormItem,
    'el-input': NullableInput
  }
})
export default class CyCfsCut extends Vue {
  @Prop({ required: true }) private milestone!: MilestoneFields;

  private debouncer = debounce((self) => { self.$emit('update', self.milestoneInput); }, 300);
  private milestoneInput: MilestoneInput = {
    details: {
      eventLocation: get(this.milestone, 'details.eventLocation', null)
    },
    eventDate: get(this.milestone, 'eventDate', null)
  };

  @Watch('milestoneInput', { deep: true })
  private emitUpdate(milestoneInput: MilestoneInput) {
    this.debouncer(this);
  }
}
